import { Component, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { merge, Observable } from 'rxjs';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { MemberUserManagementService } from '../member-user-management/member-user-management.service';
import { DumbCompanyDetails } from './DTOs/dumb-company';
import { DumbCompanyAddress } from './DTOs/dumb-company-address';
import { DumbLiaison } from './DTOs/dumb-liaison';
import { MembershipManagementService } from './membership-management.service';
import { AddEditAddressModalComponent } from './modals/add-edit-address-modal.component';
import { EditCompanyInfoModalComponent } from './modals/edit-company-info-modal.component';
import { EditCompanyLiaisonModalComponent } from './modals/edit-company-liaison.component';
import { EditCompanyPaymentInfoModalComponent } from './modals/edit-company-payment-info-modal.component';
import { EditCompanyDirectoryInfoModalComponent } from './modals/edit-company-directory-info-modal.component';

@Component({
  selector: 'app-membership-management',
  templateUrl: './membership-management.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class MembershipManagementComponent {
  constructor(private membershipService: MembershipManagementService
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService
    , private modalService: NgbModal) {
  }

    company: DumbCompanyDetails = {} as DumbCompanyDetails;
    liaison: DumbLiaison = {} as DumbLiaison;
  addresses: DumbCompanyAddress[] = [];

  ngOnInit() {
      this.getCompanyDetails();
    }

  getCompanyDetailsObservable(): Observable<DumbCompanyDetails> {
    return this.membershipService
      .getCompanyDetails();
  }

  getCompanyDetails() {
    this.blockUI.start();

    this.getCompanyDetailsObservable()
      .subscribe(
        {
          next: (data) => {
            this.company = data;
            this.liaison = data.liaison;
            this.addresses = data.addresses;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }

  openEditCompanyInfoModal() {
    const modalRef = this.modalService.open(EditCompanyInfoModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.company = this.company;
    modalRef.result.then(response => {
        this.getCompanyDetails();
    })
      .catch(err => {

      }).finally();


    }

    openEditCompanyDirectoryInfoModal() {
        const modalRef = this.modalService.open(EditCompanyDirectoryInfoModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.company = this.company;
        modalRef.result.then(response => {
            this.getCompanyDetails();
        })
            .catch(err => {

            }).finally();


    }

  openEditCompanyPaymentInfoModal() {
      const modalRef = this.modalService.open(EditCompanyPaymentInfoModalComponent, { size: 'lg', backdrop: 'static' });
      modalRef.componentInstance.company = this.company;
      modalRef.result.then(response => {
          this.getCompanyDetails();
      })
          .catch(err => {
          }).finally();
  }

  openAddEditAddressInfoModal(adding: boolean, address: DumbCompanyAddress = null) {
    const modalRef = this.modalService.open(AddEditAddressModalComponent, { size: 'lg', backdrop: 'static' });
    if (adding)
      address = new DumbCompanyAddress();
    modalRef.componentInstance.address = address;

    modalRef.componentInstance.adding = adding;

    modalRef.componentInstance.headerText = "Edit Address";

    if (adding)
      modalRef.componentInstance.headerText = "Add Address";

    modalRef.result.then(response => {
        this.getCompanyDetails();
    })
      .catch(err => {

      }).finally();

  }

  openEditLiaisonModal() {
    const modalRef = this.modalService.open(EditCompanyLiaisonModalComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.liaison = this.company.liaison;

    modalRef.result.then(response => {
        this.getCompanyDetails();
    })
      .catch(err => {

      }).finally();

  }



}
